export enum EntityStoreKey {
  rewards = 'rewards',
}
